"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyLayout = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const SurveyItem_1 = __importDefault(require("./SurveyItem"));
const constant_1 = require("./constant");
// SurveyLayout 컴포넌트
exports.SurveyLayout = react_1.default.memo(({ surveyData, setSurveyData, isRegist, isSubmit, }) => {
    const [list, setList] = react_1.default.useState(surveyData);
    (0, react_1.useEffect)(() => {
        setList(surveyData);
    }, [surveyData]);
    (0, react_1.useEffect)(() => {
        if (isSubmit)
            return;
        setSurveyData && setSurveyData(list);
    }, [list]);
    // 설문 항목 추가 함수
    const addSurveyItem = () => {
        // surveyData 배열의 길이 확인
        const length = list.length;
        // id 생성: -length를 사용하여 고유한 id 생성
        const newItemId = `survey-${(0, moment_1.default)().unix()}-${length}`;
        // 새로운 설문 항목 객체 생성
        const newItem = {
            id: newItemId,
            title: '',
            type: constant_1.SURVEY_TYPE.OBJECTIVE,
            data: [],
        };
        // 기존 surveyData 배열에 새로운 항목 추가
        const updatedList = [...list, newItem];
        // 상태 업데이트
        setList(updatedList);
    };
    // 설문 항목 삭제 함수
    const deleteSurveyItem = ({ id }) => {
        if (list && list.length > 1) {
            const newList = list.filter(item => item.id !== id);
            setList(newList);
        }
        else {
            alert('최소 1개 이상의 설문 항목이 필요합니다.');
        }
    };
    // 설문 항목 추가 및 삭제 함수
    const handlerSurveyList = (id) => {
        if (isRegist) {
            if (id) {
                deleteSurveyItem({ id });
            }
            else {
                addSurveyItem();
            }
        }
    };
    // 설문 데이터가 변경되었을 때 처리하는 함수
    const handleSurveyDataChange = (updatedItem) => {
        if (isSubmit)
            return;
        const changeItem = list.find(item => item.id === updatedItem.id);
        if (updatedItem?.title && changeItem?.title === updatedItem?.title)
            return;
        // if (
        // 	!updatedItem?.type &&
        // 	updatedItem?.data &&
        // 	_.isEqual(changeItem?.data, updatedItem?.data)
        // ) {
        // 	return;
        // }
        setList &&
            // @ts-ignore
            setList(prevData => {
                const data = prevData.map(item => {
                    if (item.id === updatedItem.id) {
                        return {
                            ...item,
                            ...updatedItem,
                        };
                    }
                    return item;
                });
                return data;
            });
        // }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, list.length > 0
        ? list.map((item, index) => (react_1.default.createElement(SurveyItem_1.default, { key: index, index: index, item: isSubmit
                ? surveyData?.find(data => data.id === item.id) || item
                : item, isSubmit: isSubmit, isRegist: isRegist, setChangeSurveyList: handlerSurveyList, setChangeSurveyData: handleSurveyDataChange })))
        : null));
});
